/* adminRecotizacionApi.js — endpoints de admin para recotizar y descargar una
 * cotización desde admin/usuarios, y la lista de aseguradoras del seguro manual.
 *
 * Todos van detrás de `check.permission` (solo admin Pei). El secret del budget
 * NUNCA viaja al front: el backend lo pone al recotizar.
 * Contrato: backend/docs/plans/admin-recotizar-placa-seguro-manual.md §4.2
 */
import axios from 'axios';
import { url } from '../env';

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    Accept: 'application/json',
});

/* { budget, seguro_actual, bloqueo, avisos } */
export const fetchRecotizacion = (budgetId, { signal } = {}) =>
    axios
        .get(`${url}/admin/cotizaciones/${budgetId}/recotizacion`, { headers: authHeaders(), signal })
        .then((res) => res.data);

/* body = payload de buildSubmitPayload() (con el seguro manual aplicado si toca).
 * Regresa la respuesta del motor + recotizacion_id. */
export const postRecotizar = (budgetId, payload) =>
    axios
        .post(`${url}/admin/cotizaciones/${budgetId}/recotizar`, payload, {
            headers: { ...authHeaders(), 'Content-Type': 'application/json' },
        })
        .then((res) => res.data);

/* DTO del PDF ({ resumen, detalle, pdfPlazo }) sin budget_secret. */
export const fetchPdfData = (budgetId, { signal } = {}) =>
    axios
        .get(`${url}/admin/cotizaciones/${budgetId}/pdf-data`, { headers: authHeaders(), signal })
        .then((res) => res.data);

/* [{ value, label }] — "Otra…" la agrega el front.
 * La lista casi no cambia: se pide una vez por carga de página y se comparte
 * (el panel de la landing se vuelve a montar en cada recotización). Si falla,
 * la siguiente llamada la vuelve a pedir. Quien la usa debe ignorar la respuesta
 * si ya se desmontó: la petición compartida no se cancela. */
let aseguradorasEnVuelo = null;
export const fetchAseguradoras = () => {
    if (!aseguradorasEnVuelo) {
        aseguradorasEnVuelo = axios
            .get(`${url}/admin/cotizaciones/aseguradoras`, { headers: authHeaders() })
            .then((res) => (Array.isArray(res.data?.aseguradoras) ? res.data.aseguradoras : []))
            .catch((err) => {
                aseguradorasEnVuelo = null;
                throw err;
            });
    }
    return aseguradorasEnVuelo;
};

/* El mensaje legible de un error de estos endpoints (o del motor). */
export const mensajeDeError = (err, fallback = 'No se pudo completar la operación.') => {
    const data = err?.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    return data?.message || data?.error || err?.message || fallback;
};
